import { useEffect } from "react";
import { CRM_BASEURL } from "../../network/url";

export default function ProductsAndPlans() {
    const subtenantId = sessionStorage.getItem('subtenantId');
    const loggedUserId = sessionStorage.getItem('loggedUserId');
    const iframeSrcUrl = `${CRM_BASEURL}/Integrations/ProductsAndPlans?subtenantId=${subtenantId}&loggedUserId=${loggedUserId}`;
    // const iframeSrcUrl = `http://localhost:3001/Integrations/ProductsAndPlans?subtenantId=${subtenantId}&loggedUserId=${loggedUserId}`;

    return (
        <div>
        <iframe title="CRM"
            src={iframeSrcUrl}
            style={{ width: '100%', height: 'calc(100vh - 100px)', border: 'none' }}
            allowFullScreen>
        </iframe>
        </div>
    )
}